
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties",
      function () {
        return require("private-next-pages/properties/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties"])
      });
    }
  